
export function GetAngleBetweenPoints(sx: number, sy: number, tx: number, ty: number): number {
	const dx: number = sx - tx
	const dy: number = sy - ty
	// dx = ex - cx
	const theta: number = Math.atan2(dy,dx) // Math.atan(dy/dx) // Math.arctan(dy/dx)
	// theta *= 180/pi // rads to degs
	return (theta * (180 / 3.141) + 90)

}

export function GetLengthBetweenPoints(sx: number, sy: number, tx: number, ty: number): number {
	const a: number = tx > sx ? tx - sx : sx - tx
	const b: number = ty > sy ? ty - sy : sy - ty
	return Math.sqrt((a*a)+(b*b))
}